// extracted by css-extract-rspack-plugin
export default {"cls1":"BlurredHiddenThumbs-cls1_jDj","cls2":"BlurredHiddenThumbs-cls2_71D BlurredHiddenThumbs-cls1_jDj"};